import { LogLevel } from "./Logger"

/**
 * Logging options.
 */
export type LoggerOptions = boolean | "all" | LogLevel[]

/**
 * File logging option.
 */
export type FileLoggerOptions = {
    /**
     * Specify custom path for log file, relative to application root
     */
    logPath: string
}
